import {configureAppStore} from './configureAppStore';
export const store = configureAppStore();